import { VCONNECT_BRAND_IMAGE, VCONNECT_NAME, VCONNECT_TAGLINE } from '../config/brand';

type BrandProps = {
  className?: string;
  compact?: boolean;
};

export function VConnectBrand({ className = '', compact = false }: BrandProps) {
  return (
    <div className={`vconnect-brand ${compact ? 'vconnect-brand-compact' : ''} ${className}`.trim()}>
      <img
        src={VCONNECT_BRAND_IMAGE}
        alt={`${VCONNECT_NAME} - ${VCONNECT_TAGLINE}`}
        className="vconnect-brand-image"
      />
    </div>
  );
}

type LoaderProps = {
  label?: string;
  compact?: boolean;
};

export function VConnectLoader({ label = 'Loading VConnect…', compact = false }: LoaderProps) {
  return (
    <div className={`vconnect-loader ${compact ? 'vconnect-loader-compact' : ''}`} role="status" aria-live="polite">
      <div className="vconnect-loader-logo-wrap" aria-hidden="true">
        <img src={VCONNECT_BRAND_IMAGE} alt="" className="vconnect-loader-logo" />
        <span className="vconnect-loader-sheen" />
      </div>
      <div className="vconnect-loader-progress" aria-hidden="true"><span /></div>
      <span className="vconnect-loader-label">{label}</span>
    </div>
  );
}
